import React, { useState, useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Link, useHistory } from 'react-router-dom';
import { Table, Modal, Button } from 'react-bootstrap';
import { FaArrowAltCircleLeft, FaArrowAltCircleRight, FaChevronDown, FaChevronUp, FaEye, FaEyeDropper, FaEyeSlash, FaNewspaper, FaRegArrowAltCircleLeft } from 'react-icons/fa';
import Navbar from '../dashboard/navbar';
import Sidebar from '../dashboard/sidebar';
import useAuth from '../dashboard/useAuth';
import axios from 'axios';

const Resultat_examen_refonte = ({ titre }) => {
    useAuth();
    const [qcms, setQcms] = useState([]);
    const [examen, setExamen] = useState([]);
    const [data, setData] = useState([]);
    const [alert, setAlert] = useState({ message: '', type: '' });
    const [showInfo, setShowInfo] = useState(false);
    const [afficherResultats, setAfficherResultats] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const location = useLocation();
    const { examen_id } = location.state || {};
    const queryParams = new URLSearchParams(location.search);

    const user_id = localStorage.getItem('user_id');
    const navigate = useNavigate();
    const resultsContainerRef = useRef(null);
    const [currentPage, setCurrentPage] = useState(1);

    // Utilisation de useEffect pour mettre à jour le titre de la page
    useEffect(() => {
        if (user_id) {
            document.title = "eTrainApp | Terminer";
        }
    }, [user_id]);

    useEffect(() => {
        scrollToTop();
    }, [currentPage]);

    const scrollToTop = () => {
        if (resultsContainerRef.current) {
            resultsContainerRef.current.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }
    };

    const renderCorrespondanceResultat = (qcm) => {
        try {
            let leftOptions = [];
            let rightOptions = [];

            // --- PARSER option1 ---
            if (typeof qcm.option1 === 'string') {
                try {
                    let option1Str = qcm.option1;
                    if (option1Str.startsWith('"') && option1Str.endsWith('"')) {
                        option1Str = option1Str.slice(1, -1);
                    }
                    option1Str = option1Str.replace(/""/g, '"');
                    leftOptions = JSON.parse(option1Str);
                    if (!Array.isArray(leftOptions)) leftOptions = [];
                } catch (e) {
                    console.error('Erreur parsing option1:', e);
                    leftOptions = [];
                }
            } else if (Array.isArray(qcm.option1)) {
                leftOptions = qcm.option1;
            }

            // --- PARSER option2 ---
            if (typeof qcm.option2 === 'string') {
                try {
                    let option2Str = qcm.option2;
                    if (option2Str.startsWith('"') && option2Str.endsWith('"')) {
                        option2Str = option2Str.slice(1, -1);
                    }
                    option2Str = option2Str.replace(/""/g, '"');
                    rightOptions = JSON.parse(option2Str);
                    if (!Array.isArray(rightOptions)) rightOptions = [];
                } catch (e) {
                    console.error('Erreur parsing option2:', e);
                    try {
                        const regex = /{"id":\s*(\d+),\s*"value":\s*"([^"]*)"}/g;
                        let match;
                        const extracted = [];
                        let tempStr = qcm.option2;
                        tempStr = tempStr.replace(/""/g, '"');
                        while ((match = regex.exec(tempStr)) !== null) {
                            extracted.push({
                                id: parseInt(match[1]),
                                value: match[2]
                            });
                        }
                        if (extracted.length > 0) {
                            rightOptions = extracted;
                        }
                    } catch (e2) {
                        console.error('Erreur extraction regex:', e2);
                        rightOptions = [];
                    }
                }
            } else if (Array.isArray(qcm.option2)) {
                rightOptions = qcm.option2;
            }

            // --- PARSER reponseCorrecte ---
            let reponseCorrecte = {};
            if (Array.isArray(qcm.reponse)) {
                console.log('reponse est un tableau:', qcm.reponse);
                try {
                    let fullStr = qcm.reponse.join('');
                    console.log('fullStr:', fullStr);
                    fullStr = fullStr.replace(/""/g, '"');
                    fullStr = fullStr.replace(/^["']|["']$/g, '');
                    const regex = /"(\d+)":\s*(\d+)/g;
                    let match;
                    while ((match = regex.exec(fullStr)) !== null) {
                        reponseCorrecte[parseInt(match[1])] = parseInt(match[2]);
                    }
                    console.log('reponseCorrecte extrait:', reponseCorrecte);
                } catch (e) {
                    console.error('Erreur parsing reponse (tableau):', e);
                }
            } else if (typeof qcm.reponse === 'string') {
                try {
                    let cleanStr = qcm.reponse;
                    cleanStr = cleanStr.replace(/""/g, '"');
                    cleanStr = cleanStr.replace(/^["']|["']$/g, '');
                    const parsed = JSON.parse(cleanStr);
                    if (typeof parsed === 'object' && !Array.isArray(parsed)) {
                        reponseCorrecte = parsed;
                    }
                } catch (e) {
                    console.error('Erreur parsing reponse (string):', e);
                    try {
                        const regex = /"(\d+)":\s*(\d+)/g;
                        let match;
                        let cleanStr = qcm.reponse.replace(/""/g, '"');
                        while ((match = regex.exec(cleanStr)) !== null) {
                            reponseCorrecte[parseInt(match[1])] = parseInt(match[2]);
                        }
                    } catch (e2) {
                        console.error('Erreur parsing reponse (string regex):', e2);
                    }
                }
            } else if (typeof qcm.reponse === 'object' && !Array.isArray(qcm.reponse)) {
                reponseCorrecte = qcm.reponse;
            }

            // --- Récupérer reponseUtilisateur ---
            const reponseUtilisateur = qcm.resultat || {};

            console.log('=== RENDER CORRESPONDANCE ===');
            console.log('leftOptions:', JSON.stringify(leftOptions));
            console.log('rightOptions:', JSON.stringify(rightOptions));
            console.log('reponseCorrecte:', JSON.stringify(reponseCorrecte));
            console.log('reponseUtilisateur:', JSON.stringify(reponseUtilisateur));

            if (leftOptions.length === 0 || rightOptions.length === 0) {
                return <div className="text-danger">
                    <p>Données de correspondance manquantes</p>
                    <p className="small">leftOptions: {leftOptions.length}, rightOptions: {rightOptions.length}</p>
                </div>;
            }

            // Vérifier si la correspondance est correcte (toutes les paires)
            const isCorrect = (() => {
                if (Object.keys(reponseUtilisateur).length === 0) return false;
                for (const key of Object.keys(reponseCorrecte)) {
                    if (!(key in reponseUtilisateur) || reponseUtilisateur[key] !== reponseCorrecte[key]) {
                        return false;
                    }
                }
                return true;
            })();

            return (
                <div style={{ margin: '10px 10px' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <thead>
                            <tr>
                                <th style={{ textAlign: 'left', padding: '5px', borderBottom: '2px solid #dee2e6' }}>Items</th>
                                <th style={{ textAlign: 'left', padding: '5px', borderBottom: '2px solid #dee2e6' }}>Réponse donnée</th>
                                <th style={{ textAlign: 'left', padding: '5px', borderBottom: '2px solid #dee2e6' }}>Statut</th>
                            </tr>
                        </thead>
                        <tbody>
                            {leftOptions.map((leftItem) => {
                                const leftId = leftItem.id;
                                const userPair = reponseUtilisateur[leftId];
                                const correctPair = reponseCorrecte[leftId];

                                let userValue = 'Non sélectionné';
                                if (userPair) {
                                    const found = rightOptions.find(r => r.id === userPair);
                                    userValue = found ? found.value : 'Non sélectionné';
                                }

                                const isItemCorrect = userPair && userPair === correctPair;

                                return (
                                    <tr key={leftId} style={{ borderBottom: '1px solid #e9ecef' }}>
                                        <td style={{ padding: '8px 5px', verticalAlign: 'middle' }}>
                                            <span style={{ fontWeight: '500' }}>{leftItem.value || `Item ${leftId}`}</span>
                                        </td>
                                        <td style={{ padding: '8px 5px', verticalAlign: 'middle' }}>
                                            <span>{userValue}</span>
                                        </td>
                                        <td style={{ padding: '8px 5px', verticalAlign: 'middle' }}>
                                            {userPair ? (
                                                isItemCorrect ? (
                                                    <i className="fa fa-thumbs-up" style={{ color: 'green', fontSize: '20px' }} title="Correct"></i>
                                                ) : (
                                                    <i className="fa fa-thumbs-down" style={{ color: 'red', fontSize: '20px' }} title="Incorrect"></i>
                                                )
                                            ) : (
                                                <i className="fa fa-minus-circle" style={{ color: 'orange', fontSize: '20px' }} title="Non répondu"></i>
                                            )}
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>

                    {/* VOTRE RÉPONSE AVEC BADGE APRÈS */}
                    <div style={{
                        marginTop: '10px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        flexWrap: 'wrap',
                        justifyContent: 'right'
                    }}>
                        {/* <span style={{ fontWeight: 'bold', fontSize: '13px' }}>Votre réponse :</span>
                    <span style={{ fontSize: '13px' }}>
                        {(() => {
                            const pairs = Object.entries(reponseUtilisateur);
                            if (pairs.length === 0) return 'Aucune réponse';
                            return pairs.map(([left, right]) => {
                                const found = rightOptions.find(r => r.id === right);
                                return found ? `${left} → ${found.value}` : `${left} → ?`;
                            }).join(' ; ');
                        })()}
                    </span> */}
                        <span style={{
                            padding: '2px 10px',
                            borderRadius: '4px',
                            fontWeight: 'bold',
                            fontSize: '12px',
                            backgroundColor: isCorrect ? '#28a745' : '#dc3545',
                            color: 'white',
                            display: 'inline-block',
                            marginLeft: '5px'
                        }}>
                            {isCorrect ? '✅ Correct' : '❌ Incorrect'}
                        </span>
                    </div>

                    {/* BONNES RÉPONSES */}
                    {/* <div style={{ marginTop: '5px', fontStyle: 'italic', color: 'blue', fontSize: '13px' }}>
                    <strong>Bonnes réponses :</strong> {
                        leftOptions.map((leftItem) => {
                            const correctPair = reponseCorrecte[leftItem.id];
                            if (correctPair) {
                                const foundRight = rightOptions.find(r => r.id === correctPair);
                                return foundRight ? `${leftItem.value} → ${foundRight.value}` : null;
                            }
                            return null;
                        }).filter(Boolean).join(' ; ')
                    }
                </div> */}

                    {/* EXPLICATION */}
                    {qcm.explication && qcm.explication !== 'non défini' && (
                        <div style={{ color: 'green', marginTop: '5px', fontSize: '13px' }}>
                            <strong>Explication :</strong>{' '}
                            <span dangerouslySetInnerHTML={{ __html: qcm.explication }} />
                        </div>
                    )}
                </div>
            );
        } catch (e) {
            console.error('Erreur rendu correspondance:', e);
            return <div className="text-danger">Erreur d'affichage des correspondances: {e.message}</div>;
        }
    };


    const [examenblancDetails, setExamenblancDetails] = useState([]);


    // useEffect(() => {
    //     const fetchData = async () => {
    //         setIsLoading(true); // Indiquer le début du chargement

    //         try {
    //             // Récupérer d'abord les détails de l'examen
    //             const examenResponse = await fetch(`${process.env.REACT_APP_HOTE}/recuperer-examenblanc/${examen_id}/${user_id}`);
    //             if (examenResponse.ok) {
    //                 const examenData = await examenResponse.json();
    //                 setExamenblancDetails(examenData);
    //             }
    //         } catch (error) {
    //             console.error('Erreur lors de la récupération des données:', error);
    //         } finally {
    //             setIsLoading(false); // Indiquer la fin du chargement
    //         }
    //     };

    //     fetchData();
    // }, [examen_id, user_id]); // Exécuter seulement si `examen_id` ou `user_id` change



    // Handle alerts
    const showAlert = (message, type = 'success') => {
        setAlert({ message, type });
        setTimeout(() => {
            setAlert({ message: '', type: '' });
            handleFinishExamen()
        }, 3000);
    };

    
    const itemsParPage = 5;


    const totalPages = Math.ceil(qcms.length / itemsParPage);


    const debutIndex = (currentPage - 1) * itemsParPage;
    const finIndex = debutIndex + itemsParPage;
    const currentQcms = qcms.slice(debutIndex, finIndex);


    const pageSuivante = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const pagePrecedente = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleFinishExamen = async () => {
        setIsLoading(true)
        // Logique de terminaison de simulation
        try {
            const response = await fetch(`${process.env.REACT_APP_HOTE}/examen-donnes-resultats-refonte/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    user_id: user_id,
                    examen_id: examen_id,
                }),
            });
            if (response.ok) {
                setIsLoading(false)
                const data = await response.json();
                console.log('data qcm refonte', data)
                setData(data);
                setQcms(data.qcms)
            } else {
                setIsLoading(false)
                console.error('Erreur lors de la récupérationnnn');
            }
        } catch (error) {
            setIsLoading(false)
            console.error('Erreur réseau:', error);
        }
    };
    useEffect(() => {
        handleFinishExamen();
    }, []);

    const [accesGroupe, setAccesGroupe] = useState([]);
    const [groupeId, setGroupeId] = useState(null);
    const groupe = localStorage.getItem('groupe');

    const verifGroupe = async () => {
        const groupeStored = localStorage.getItem('groupe');
        const accesGroupeStored = localStorage.getItem('accesGroupe');

        if (groupeStored && accesGroupeStored) {
            setGroupeId(groupeStored);
            setAccesGroupe(JSON.parse(accesGroupeStored));
        } else {
            try {
                const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}/`);
                if (response.status === 200) {
                    const data = response.data;
                    setGroupeId(data.groupe);

                    let cleanedAccessArray = [];
                    if (Array.isArray(data.acces)) {
                        cleanedAccessArray = data.acces.map((item) =>
                            item.acces
                                ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
                                : []
                        ).flat();

                        setAccesGroupe(cleanedAccessArray);
                    }

                    localStorage.setItem('groupe', data.groupe);
                    localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
                }
            } catch (error) {
                // console.error('Erreur lors de la vérification du groupe', error);
            }
        }
    };

    useEffect(() => {
        if (user_id) {
            verifGroupe();
        }
    }, [user_id]);

    if (!accesGroupe.includes("ExamenBlanc")) {
        return (
            <div id="wrapper">
                <Sidebar user_id={user_id} />
                <div id="page-wrapper" className="gray-bg">
                    <Navbar />
                    <div className="wrapper wrapper-content animated fadeInRight">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="ibox">
                                    <div className="ibox-content text-center p-5">
                                        <div className="mb-4">
                                            <i className="fa fa-lock fa-5x text-warning"></i>
                                        </div>
                                        <h2>Accès restreint</h2>
                                        <p className="lead mb-4">
                                            Vous n'avez pas les autorisations nécessaires pour accéder à cette page.
                                        </p>
                                        <div className="d-flex justify-content-center">
                                            <Link to="/" className="btn btn-primary">
                                                <i className="fa fa-arrow-left mr-2"></i>
                                                Retour
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <div className='row align-items-end'>
                                <h2><FaNewspaper size={25} className='mr-2' />
                                    {/* {data?.langue === 'Fr' ? 'Resultat Examen Blanc' : 'Exam result'} */}
                                    Résultat de l'{data?.type_examen === 'Essai' ? 'Essai' : 'Examen Blanc'}
                                </h2>
                                <span
                                    className="ml-3 toggle-icon"
                                    style={{ cursor: 'pointer', marginBottom: '10px' }}
                                    onClick={() => setShowInfo(!showInfo)}
                                >
                                    {showInfo ? <FaChevronUp /> : <FaChevronDown />}
                                </span>
                            </div>
                            <div className={`info-box ${showInfo ? "open" : ""}`}>
                                {/* {data?.langue === 'Fr' ? (
                                    <small>
                                        Résultat et correction de l'examen. Les explications et les éventuelles références au Guide PMBOK aident à mieux comprendre la logique des questions.
                                    </small>
                                ) : (
                                    <small>
                                        Exam results and corrections, along with explanations and possible references to the PMBOK Guide, help provide a better understanding of the logic behind the questions.
                                    </small>
                                )} */}
                                <small>
                                    Résultat et correction de l'examen. Les explications et les éventuelles références au Guide PMBOK aident à mieux comprendre la logique des questions.
                                </small>

                            </div>
                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Historique-complet`}> Simulateur </Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        Résultat {examen_id}
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>

                    <div className="container mt-3 wrapper wrapper-content animated fadeInRight">
                        <div className="row d-flex justify-content-center">
                            <div className="col-lg-8 mx-auto">
                                <div className="ibox ">
                                    <div className="ibox-title p-3">
                                        <div className='p-2 d-flex align-items-center justify-content-between'>
                                            <h5>Résultat de l'{data?.type_examen === 'Essai' ? 'Essai' : 'Examen Blanc'}</h5>
                                            {/* <h5>{data?.langue === 'Fr' ? "Résultat de l\'Examen Blanc" : "Exam Results"}</h5> */}
                                            <span
                                                className='label label-primary mb-2'
                                                style={{ cursor: 'pointer' }}
                                                onClick={() => setAfficherResultats(!afficherResultats)}
                                            >
                                                <span className='mr-2'>Voir corrigé</span>
                                                {afficherResultats ? <FaEye /> : <FaEyeSlash />}
                                            </span>
                                        </div>

                                        {isLoading ? (
                                            <div className="text-center">
                                                <span className="spinner-border text-success" role="status"></span>
                                                <p>Chargement des résultats...</p>
                                            </div>
                                        ) : (
                                            <div className="table-responsive">
                                                {examen ? (
                                                    <table className="table table-striped table-hover">
                                                        <tr>
                                                            {/* <td>{data?.langue === 'Fr' ? "Date et heure" : "Date and Time"}</td> */}
                                                            <td>Date et heure</td>
                                                            <td>{data?.date_examen}</td>
                                                            {/* <td>{data?.langue === 'Fr' ? "Niveau" : "Level"}</td> */}
                                                            <td>Niveau</td>
                                                            <td>{data?.type_examen}</td>
                                                        </tr>
                                                        {data?.type_examen !== 'Essai' &&

                                                            <tr>
                                                                <td>Heure de Début</td>
                                                                {/* <td>{data?.langue === 'Fr' ? "Heure de Début" : "Start Time"}</td> */}
                                                                <td>{data?.heureDebut}</td>
                                                                <td>Heure de Fin</td>
                                                                {/* <td>{data?.langue === 'Fr' ? "Heure de Fin" : "End Time"}</td> */}
                                                                <td>{data?.heureFin}</td>
                                                            </tr>
                                                        }
                                                        <tr>
                                                            <td>Nombre de Questions</td>
                                                            {/* <td>{data?.langue === 'Fr' ? "Nombre de Questions" : "Total Questions"}</td> */}
                                                            <td>{data?.total_questions}</td>
                                                            <td>Questions traitées</td>
                                                            {/* <td>{data?.langue === 'Fr' ? "Questions traitées" : "Questions Answered"}</td> */}
                                                            <td>{data?.questions_traitees}/{data?.total_questions}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Pourcentage</td>
                                                            {/* <td>{data?.langue === 'Fr' ? "Pourcentage" : "Percent"}</td> */}
                                                            <td>
                                                                <div className="progress m-t-xs full">
                                                                    <div
                                                                        className={`progress-bar ${data?.pourcent < 80 ? 'progress-bar-danger' : 'progress-bar-success'}`}
                                                                        role="progressbar"
                                                                        aria-valuemin="0"
                                                                        aria-valuemax="100"
                                                                        aria-valuenow={data?.pourcent}
                                                                        style={{ width: `${data?.pourcent}%` }}
                                                                    >
                                                                        <span className={data?.pourcent === 0 ? 'text-dark' : ''}>
                                                                            {data?.pourcent}%
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                <div style={{ color: data?.pourcent < 80 ? "red" : "green" }}>
                                                                    {data?.pourcent < 80 ? "Echec (< 80%)" : "Réussite (>= 80%)"}
                                                                </div>
                                                            </td>
                                                            <td>Bonnes réponses</td>
                                                            {/* <td>{data?.langue === 'Fr' ? "Bonnes réponses" : "Corrects Answers"}</td> */}
                                                            <td>{data?.nombre_correct}/{data?.total_questions}</td>
                                                        </tr>
                                                    </table>
                                                ) : null}
                                            </div>
                                        )}

                                    </div>
                                    <div className="ibox-content text-dark" ref={resultsContainerRef}>
                                        <div>
                                            {
                                                afficherResultats && (
                                                    <div className={`${afficherResultats ? "open" : ""}`}>
                                                        {currentQcms.length > 0 ? (
                                                            currentQcms.map((qcm) => (
                                                                <div key={qcm.id} style={{ borderBottom: '1px solid #ccc', paddingBottom: '15px', marginBottom: '15px', fontSize: '12px' }}>
                                                                    <input type="hidden" name="qcmidhidden" id="qcmidhidden" value={qcm.id} />

                                                                    <div>
                                                                        <span># {qcm.ref} - </span>
                                                                        <span id="question" style={{ fontSize: '12px' }} dangerouslySetInnerHTML={{ __html: qcm.question }}></span>
                                                                    </div>

                                                                    {qcm.type_question === 'correspondance' ? (
                                                                        renderCorrespondanceResultat(qcm)
                                                                    ) : (
                                                                        // Questions par défaut
                                                                        <>
                                                                            <div style={{ margin: '10px 10px' }}>
                                                                                {Object.keys(qcm)
                                                                                    .filter((key) => key.startsWith('option') && (qcm[key] !== 'non défini' && qcm[key] !== 'vide'))
                                                                                    .map((key, index) => {
                                                                                        const optionLetter = String.fromCharCode(65 + index);
                                                                                        const optionText = qcm[key];
                                                                                        const isCorrect = Array.isArray(qcm.reponse) && qcm.reponse.includes(optionLetter);
                                                                                        const isSelected = Array.isArray(qcm.resultat) && qcm.resultat.includes(optionLetter);

                                                                                        let bgColor = 'transparent';
                                                                                        if (isSelected && isCorrect) {
                                                                                            bgColor = '#d4edda';
                                                                                        } else if (isSelected && !isCorrect) {
                                                                                            bgColor = '#f8d7da';
                                                                                        } else if (!isSelected && isCorrect) {
                                                                                            bgColor = '#e8f5e9';
                                                                                        }

                                                                                        return (
                                                                                            <div key={key} style={{
                                                                                                display: 'flex',
                                                                                                // alignItems: 'center',
                                                                                                marginBottom: '8px',
                                                                                                fontSize: '12px',
                                                                                                padding: '5px 10px',
                                                                                                borderRadius: '4px',
                                                                                                backgroundColor: bgColor,
                                                                                                border: isSelected && isCorrect ? '1px solid #28a745' :
                                                                                                    isSelected && !isCorrect ? '1px solid #dc3545' : '1px solid transparent'
                                                                                            }}>
                                                                                                <span style={{ minWidth: '25px', fontWeight: 'bold' }}>
                                                                                                    {optionLetter} -
                                                                                                </span>
                                                                                                <span style={{ flex: 1 }}>
                                                                                                    {optionText}
                                                                                                </span>
                                                                                                {isCorrect && isSelected ? (
                                                                                                    <i className="fa fa-check-circle" style={{ color: 'green', fontSize: '18px', alignContent: 'center' }} title="Bonne réponse sélectionnée"></i>
                                                                                                ) : isCorrect ? (
                                                                                                    <i className="fa fa-circle-o" style={{ color: '#6c757d', fontSize: '16px', alignContent: 'center' }} title="Bonne réponse non sélectionnée"></i>
                                                                                                ) : isSelected ? (
                                                                                                    <i className="fa fa-times-circle" style={{ color: 'red', fontSize: '18px', alignContent: 'center' }} title="Mauvaise réponse sélectionnée"></i>
                                                                                                ) : null}
                                                                                            </div>
                                                                                        );
                                                                                    })}
                                                                            </div>

                                                                            {/* VOTRE RÉPONSE AVEC BADGE APRÈS */}
                                                                            <div style={{
                                                                                marginTop: '10px',
                                                                                display: 'flex',
                                                                                alignItems: 'center',
                                                                                gap: '8px',
                                                                                flexWrap: 'wrap',
                                                                                justifyContent: 'space-between'
                                                                            }}>
                                                                                <span style={{ fontWeight: 'bold', fontSize: '13px' }}>Votre réponse : <span style={{ fontSize: '13px' }}>
                                                                                    {(() => {
                                                                                        const userAnswers = Array.isArray(qcm.resultat) ? qcm.resultat : [];
                                                                                        return userAnswers.length > 0 ? userAnswers.join(', ') : 'Aucune réponse';
                                                                                    })()}
                                                                                </span></span>

                                                                                {(() => {
                                                                                    const userAnswers = Array.isArray(qcm.resultat) ? qcm.resultat : [];
                                                                                    const correctAnswers = Array.isArray(qcm.reponse) ? qcm.reponse : [];
                                                                                    const isCorrect = userAnswers.length > 0 &&
                                                                                        JSON.stringify([...userAnswers].sort()) === JSON.stringify([...correctAnswers].sort());
                                                                                    return (
                                                                                        <span style={{
                                                                                            padding: '2px 10px',
                                                                                            borderRadius: '4px',
                                                                                            fontWeight: 'bold',
                                                                                            fontSize: '12px',
                                                                                            backgroundColor: isCorrect ? '#28a745' : '#dc3545',
                                                                                            color: 'white',
                                                                                            display: 'inline-block',
                                                                                            marginLeft: '5px'
                                                                                        }}>
                                                                                            {isCorrect ? '✅ Correct' : '❌ Incorrect'}
                                                                                        </span>
                                                                                    );
                                                                                })()}
                                                                            </div>

                                                                            {/* BONNES RÉPONSES */}
                                                                            <div style={{ marginTop: '5px', fontStyle: 'italic', color: 'blue', fontSize: '13px' }}>
                                                                                <strong>Bonnes réponses :</strong> {qcm.reponse && Array.isArray(qcm.reponse) ? qcm.reponse.join(' , ') : 'Aucune'}
                                                                            </div>

                                                                            {/* EXPLICATION */}
                                                                            {qcm.explication && qcm.explication !== 'non défini' && (
                                                                                <div style={{ color: 'green', marginTop: '5px', fontSize: '13px' }}>
                                                                                    <strong>Explication :</strong>{' '}
                                                                                    <span dangerouslySetInnerHTML={{ __html: qcm.explication }} />
                                                                                </div>
                                                                            )}
                                                                        </>
                                                                    )}

                                                                    {/* <div style={{ marginTop: '10px', fontStyle: 'italic', color: 'blue' }}>
                                                                        <p>{data?.langue === 'Fr' ? "Bonnes réponses : " : "Corrects answers : "}{qcm.reponse.join(' , ')}</p>
                                                                    </div> */}


                                                                </div>
                                                            ))
                                                        ) : (
                                                            <p>Aucun QCM avec résultat trouvé pour cet examen.</p>
                                                        )}

                                                        {/* Pagination controls */}
                                                        {totalPages > 1 && (
                                                            <div className="d-flex align-items-center mt-4 mb-4">
                                                                {currentPage > 1 && (
                                                                    <Button className="btn btn-success me-2" onClick={pagePrecedente}>
                                                                        <FaArrowAltCircleLeft />
                                                                    </Button>
                                                                )}

                                                                <span className="flex-grow-1 text-center">Page {currentPage} sur {totalPages}</span>

                                                                {currentPage < totalPages && (
                                                                    <Button className="btn btn-success ms-2" onClick={pageSuivante}>
                                                                        <FaArrowAltCircleRight />
                                                                    </Button>
                                                                )}
                                                            </div>


                                                        )}
                                                    </div>
                                                )
                                            }
                                        </div>

                                        <div className="d-flex justify-content-end">
                                            <Button
                                                className='btn btn-success d-flex align-items-center justify-between'
                                                onClick={() => navigate('/Historique-complet')}
                                            >
                                                <FaRegArrowAltCircleLeft className='mr-1' /> Retour à la liste des examens
                                                {/* <FaRegArrowAltCircleLeft className='mr-1' /> {data?.langue === 'Fr' ? "Retour à la liste des examens" : "Return to exam list"} */}
                                            </Button>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    );
};

export default Resultat_examen_refonte;
